<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button v-if="addPower" type="primary" icon="el-icon-plus" size="small" @click="setAddAndModify(false)">新建ADX</el-button>
        </li>
        <li>
          <span>ADX名称：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryAdxName" @input="getList"></el-input>
        </li>
        <li>
          <span>状态：</span>
          <el-select size="small" v-model="queryStatus" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in myOption.status" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="ListMain-table-expand">
              <el-form-item label="创建时间">
                <span>{{ props.row.createTime }}</span>
              </el-form-item>
              <el-form-item label="最后修改时间">
                <span>{{ props.row.updateTime }}</span>
              </el-form-item>
              <el-form-item label="修改人">
                <span>{{ props.row.modifier }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{ props.row.remark }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="adxId" label="ID" min-width="100"></el-table-column>
        <el-table-column prop="adxName" label="ADX名称" min-width="200"></el-table-column>
        <el-table-column prop="protocolType" label="协议类型" min-width="150"></el-table-column>
        <el-table-column prop="encryptKey" label="加密密钥" min-width="300"></el-table-column>
        <el-table-column prop="checkKey" label="校验密钥" min-width="300"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="tableData[scope.$index].status" :disabled="!statusPower" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="setStatus(tableData[scope.$index])"></el-switch>
          </template>
        </el-table-column>
        <el-table-column v-if="addPower || deletePower || modifyPower" min-width="150">
          <template slot="header" slot-scope="scope">操作</template>
          <template slot-scope="scope">
            <el-button v-if="modifyPower" type="text" size="small" @click="setAddAndModify(tableData[scope.$index])">修改</el-button>
            <el-button v-if="deletePower" type="text" size="small" style="color: #F56C6C" @click="setDelete(tableData[scope.$index])">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'List',
  components: {
    Pagination
  },
  data () {
    return {
      isSspUser: this.$store.getters.isMediaOwner,
      isLoading: true,
      thisModule: [],
      tableData: [],
      addPower: false,
      deletePower: false,
      modifyPower: false,
      statusPower: false,
      userData: [],
      queryUser: '',
      queryStatus: '',
      queryAdxName: ''
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.adx.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      let power = powers[1200].powerValue
      // 新建
      if ((power & thisModule.add.power) === thisModule.add.power) {
        this.addPower = true
      }
      // 删除
      if ((power & thisModule.delete.power) === thisModule.delete.power) {
        this.deletePower = true
      }
      // 修改
      if ((power & thisModule.modify.power) === thisModule.modify.power) {
        this.modifyPower = true
      }
      // 启用/禁用
      if ((power & thisModule.status.power) === thisModule.status.power) {
        this.statusPower = true
      }
    })
    // 缓存模块配置
    this.thisModule = thisModule
    // 获取缓存筛选数据
    this.myOption.getScreenData(this, 'screen-adx')
    // 判断是否为媒体主
    if (this.isSspUser) {
      // 调用获取列表函数
      this.getList()
    } else {
      // 调用获取列表函数
      this.getList()
    }
  },
  methods: {
    // 获取列表
    getList () {
      let param = {
        adxName: this.queryAdxName,
        status: this.queryStatus,
        startPage: this.$store.state.user.currentPage,
        pageSize: this.$store.state.user.pageSize
      }
      if (this.isSspUser) {
        param.userId = this.queryUser
      }
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.api,
        data: this.qs.stringify(param)
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          for (let val of data) {
            val.protocolType = this.myOption.getIdData('protocolType', val.protocolType, 'name')
          }
          this.tableData = data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 新增和修改
    setAddAndModify (data, isCopy) {
      if (data) {
        this.$store.dispatch('SetEditId', {id: data.adxId, copy: isCopy || false})
      }
      let param = {}
      if (this.queryAdxName !== '') {
        param.queryAdxName = this.queryAdxName
      }
      if (this.queryStatus !== '') {
        param.queryStatus = this.queryStatus
      }
      if (this.$store.state.user.currentPage !== 1) {
        param.startPage = this.$store.state.user.currentPage
      }
      if (this.$store.state.user.pageSize !== 10) {
        param.startPage = this.$store.state.user.pageSize
      }
      if (Object.keys(param).length > 0) {
        window.sessionStorage.setItem('screen-adx', JSON.stringify(param))
      }
      this.myOption.switchListAndEdit(this, false)
    },
    // 删除
    setDelete (param) {
      this.$confirm(`是否删除 "${param.adxName}" ADX`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.delete.id
          },
          url: this.myOption.requestUrl + this.thisModule.delete.api,
          data: this.qs.stringify({
            adxIds: param.adxId
          })
        }).then(res => {
          const code = res.data.code
          if (res.data.code === 200) {
            this.$message.success('删除ADX成功')
            this.getList()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      }).catch(() => {})
    },
    // 启用/禁用
    setStatus (param) {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.status.id
        },
        url: this.myOption.requestUrl + this.thisModule.status.api,
        data: this.qs.stringify({
          adxId: param.adxId,
          status: param.status
        })
      }).then(res => {
        const code = res.data.code
        if (res.data.code === 200) {
          this.$message.success(`${param.status === 1 ? '启用' : '禁用'}ADX成功`)
        } else {
          this.myOption.abnormalCode(this, code)
          param.status = !param.status
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        param.status = !param.status
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/adx/List.vue